const RedisKeys = {
  NOTIFICATIONS_TOGGLE: 'NOTIFICATIONS_TOGGLE:%(clientId)s',
  MASTER_INDENT_STATUS_UPDATE: 'MASTER_INDENT_STATUS_UPDATE:%(data)s',
  MDM_UPLOAD_CONSIGNEES_STATUS: 'MDM_UPLOAD_CONSIGNEES_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_CONSIGNEES_OPTIONAL_FIELDS_STATUS: 'MDM_UPLOAD_CONSIGNEES_OPTIONAL_FIELDS_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_COSTCENTER_STATUS: 'MDM_UPLOAD_COSTCENTER_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_DETENTION_STATUS: 'MDM_UPLOAD_DETENTION_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_TRANSPORTER_STATUS: 'MDM_UPLOAD_TRANSPORTER_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_RATEMATRIX_STATUS: 'MDM_UPLOAD_RATEMATRIX_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_CONTRACTS_STATUS: 'MDM_UPLOAD_CONTRACTS_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_CONTRACTS_TSD_MAP_STATUS: 'MDM_UPLOAD_CONTRACTS_TSD_MAP_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_BASE_DIESEL_RATE_STATUS: 'MDM_UPLOAD_BASE_DIESEL_RATE_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_MATERIAL_STATUS: 'MDM_UPLOAD_MATERIAL_STATUS:%(clientId)s:%(userId)s',
  ERP_MATERIAL_DELETE_STATUS: 'ERP_MATERIAL_DELETE_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_INVOKE_RUN_STATUS: 'OPTIMA_INVOKE_RUN_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_CREATE_INDENTS_STATUS: 'OPTIMA_CREATE_INDENTS_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_CREATE_INDENTS_STATUS_DEL_GRP: 'OPTIMA_CREATE_INDENTS_STATUS_DEL_GRP:%(clientId)s:%(userId)s:%(optimaId)s',
  OPTIMA_MATERIAL_UPLOAD_STATUS: 'OPTIMA_MATERIAL_UPLOAD_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_MATERIAL_MOVE_TO_PENDING_STATUS: 'OPTIMA_MATERIAL_MOVE_TO_PENDING_STATUS:%(clientId)s:%(userId)s',
  ORDER_BULK_UPLOAD: 'ORDER_BULK_UPLOAD:%(clientId)s:%(userId)s',
  TRUCK_ASSIGN_BULK_UPLOAD: 'TRUCK_ASSIGN_BULK_UPLOAD:%(clientId)s:%(userId)s',
  DIRECT_DELIVERY_ORDER_BULK_UPLOAD: 'DIRECT_DELIVERY_ORDER_BULK_UPLOAD:%(clientId)s:%(userId)s',
  DIRECT_DISPATCH_BULK_UPLOAD: 'DIRECT_DISPATCH_BULK_UPLOAD:%(clientId)s:%(userId)s',
  PAYMENT_STATUS_BULK_UPLOAD: 'PAYMENT_STATUS_BULK_UPLOAD:%(clientId)s:%(userId)s',
  GRN_MATERIAL_UPLOAD_STATUS: 'GRN_MATERIAL_UPLOAD_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_VEHICLE_STATUS: 'MDM_UPLOAD_VEHICLE_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_VEHICLE_DETAIL_STATUS: 'MDM_UPLOAD_VEHICLE_DETAIL_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_DEDICATED_TRUCK_STATUS: 'MDM_UPLOAD_DEDICATED_TRUCK_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_BILL_DISCOUNT_STATUS: 'MDM_UPLOAD_BILL_DISCOUNT_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_TRANSIT_STATUS: 'MDM_UPLOAD_TRANSIT_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_LATEST_JOB_RUN: 'OPTIMA_LATEST_JOB_RUN:%(clientId)s:%(userId)s',
  OPTIMA_MATERIALS: 'OPTIMA_MATERIALS:%(clientId)s:%(userId)s',
  MODIFY_PICKLIST: 'MODIFY_PICKLIST:%(clientId)s:%(userId)s',
  ERP_MATERIAL_INVOICE: 'ERP_MATERIAL_INVOICE:%(clientId)s:%(userId)s',
  OPTIMA_LATEST_META: 'OPTIMA_LATEST_META:%(clientId)s:%(depotId)s:%(movement)s',
  OPTIMA_LATEST_ID_BY_DEPOT_ID: 'OPTIMA_LATEST_ID_BY_DEPOT_ID:%(clientId)s:%(depotId)s:%(movement)s',
  OPTIMA_SUBMIT_JOB_LOCK_BY_DEPOT_ID: 'OPTIMA_SUBMIT_JOB_LOCK_BY_DEPOT_ID:%(clientId)s:%(depotId)s:%(movement)s',
  ERP_EPOD_UPDATE: 'ERP_EPOD_UPDATE:%(clientId)s:%(userId)s',
  MDM_UPLOAD_LODING_UNLOADING_STATUS: 'MDM_LOADING_UNLOADING_CHARGES',
  MDM_SLA_STATUS: 'MDM_SLA_CHARGES',
  MDM_UPLOAD_ASSOCIATED_MATERIAL_STATUS: 'MDM_UPLOAD_ASSOCIATED_MATERIAL_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_USER_STATUS: 'MDM_UPLOAD_USER_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_EXTRA_DROP_CHARGE_STATUS: 'MDM_UPLOAD_EXTRA_DROP_CHARGE_STATUS:%(clientId)s:%(userId)s',
  MATERIALS_ACROSS_INDENT: 'MATERIALS_ACROSS_INDENT:%(clientId)s:%(userId)s',
  MATERIALS_WITH_PACKAGE_ACROSS_INDENT: 'MATERIALS_WITH_PACKAGE_ACROSS_INDENT:%(clientId)s:%(userId)s',
  MDM_UPLOAD_DEPOT_STATUS: 'MDM_UPLOAD_DEPOT_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_TRANSSHIPMENT_STATUS: 'MDM_UPLOAD_TRANSSHIPMENT_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_GATE_STATUS: 'MDM_UPLOAD_GATE_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_DELIVERY_RUN_UPLOAD_STATUS: 'OPTIMA_DELIVERY_RUN_UPLOAD_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_CLOUD_EXPORT_PATH: 'OPTIMA_CLOUD_EXPORT_PATH:%(depotId)s:%(jobId)s',
  OPTIMA_CUSTOM_BUCKET_NAME: 'OPTIMA_CUSTOM_BUCKET_NAME:%(clientID)s',
  OPTIMA_PTL_EXPORT: 'OPTIMA_PTL_EXPORT:%(clientId)s:%(depotId)s:%(movement)s',
  OPTIMA_INDENT_COMBINE: 'OPTIMA_INDENT_COMBINE:%(clientId)s:%(userId)s',
  MDM_UPLOAD_LOCATION_STATUS: 'MDM_UPLOAD_LOCATION_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_VENDOR_UPLOAD_STATUS: 'OPTIMA_VENDOR_UPLOAD_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_PORT_STATUS: 'MDM_UPLOAD_PORT_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_EXIM_CHA_STATUS: 'MDM_UPLOAD_EXIM_CHA_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_EXIM_CONTAINER_STATUS: 'MDM_UPLOAD_EXIM_CONTAINER_STATUS:%(clientId)s:%(userId)s',
  MDM_PURCHASE_ORDER_STATUS: 'MDM_PURCHASE_ORDER_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_TRANSPORTATION_DB_STATUS: 'MDM_UPLOAD_TRANSPORTATION_DB_STATUS:%(clientId)s:%(userId)s',
  MATERIALS_INVOICE_GRN_INDENT: 'MATERIALS_INVOICE_GRN_INDENT:%(clientId)s:%(userId)s',
  INDENT_MARK_AS_DELIVER: 'INDENT_MARK_AS_DELIVER:%(clientId)s:%(orderNo)s',
  MDM_VEHICLE_DETAIL_BULK_UPLOAD: 'MDM_VEHICLE_DETAIL_BULK_UPLOAD',
  MDM_DRIVER_IMPORT: 'MDM_DRIVER_IMPORT:%(clientId)s:%(userId)s',
  INDENT_MATERIAL_BULK_DELETE: 'INDENT_MATERIAL_BULK_DELETE:%(clientId)s:%(userId)s',
  CONSIGNMENT_BULK_UPLOAD_STATUS: 'CONSIGNMENT_BULK_UPLOAD_STATUS:%(clientId)s:%(userId)s:%(transporterId)s',


  // All PTL Actions
  PTL_GROUP_TRUCK_ASSIGN_STATUS: 'PTL_GROUP_TRUCK_ASSIGN_STATUS:%(clientId)s:%(userId)s',
  PTL_GROUP_INDENT_ACCEPT_REJECT: 'PTL_GROUP_INDENT_ACCEPT_REJECT:%(clientId)s:%(ptlGroupId)s:%(type)s',
  PTL_GROUP_TRUCK_IN_STATUS: 'PTL_GROUP_TRUCK_IN_STATUS:%(clientId)s:%(ptlGroupId)s',
  PTL_GROUP_TRUCK_OUT_STATUS: 'PTL_GROUP_TRUCK_OUT_STATUS:%(clientId)s:%(ptlGroupId)s',
  PTL_GROUP_START_LOAD_STATUS: 'PTL_GROUP_START_LOAD_STATUS:%(clientId)s:%(ptlGroupId)s',
  PTL_GROUP_END_LOAD_STATUS: 'PTL_GROUP_END_LOAD_STATUS:%(clientId)s:%(ptlGroupId)s',
  PTL_GROUP_REPORT_DEPOT_STATUS: 'PTL_GROUP_REPORT_DEPOT_STATUS:%(clientId)s:%(ptlGroupId)s',
  SHIPPER_REPORT_AT_GATE_PASS_LOCK: 'SHIPPER_REPORT_AT_GATE_PASS_LOCK:%(clientId)s:%(orderNo)s',
  PTL_GROUP_UPDATE_TRUCK_STATUS: 'PTL_GROUP_UPDATE_TRUCK_STATUS:%(clientId)s:%(ptlGroupId)s',
  PTL_GROUP_INSPECTION_STATUS: 'PTL_GROUP_INSPECTION_STATUS:%(clientId)s:%(ptlGroupId)s',
  PTL_GROUP_LOAD_POINT_STATUS: 'PTL_GROUP_LOAD_POINT_STATUS:%(clientId)s:%(ptlGroupId)s',

  MDM_BULK_UPLOAD_STATUS: 'MDM_BULK_UPLOAD_STATUS:%(clientId)s:%(userId)s:%(type)s',
  PTL_GROUP_TRUCK_ASSIGN_STATUS: 'PTL_GROUP_TRUCK_ASSIGN_STATUS',


  MDM_UPLOAD_PACKAGE_MASTER_STATUS: 'MDM_UPLOAD_PACKAGE_MASTER_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_MATERIAL_PACKAGE_MAPPING_STATUS: 'MDM_UPLOAD_MATERIAL_PACKAGE_MAPPING_STATUS:%(clientId)s:%(userId)s',
  ERP_TRUCK_IN: 'ERP_TRUCK_IN:%(clientId)s:%(userId)s',
  ERP_TRUCK_OUT_STATUS: 'ERP_TRUCK_OUT_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_USER_ASSOCIATE_STATUS: 'MDM_UPLOAD_USER_ASSOCIATE_STATUS::%(clientId)s:%(userId)s',
  PRE_PLAN_MATERIAL: 'PRE_PLAN_MATERIAL:%(clientId)s:%(userId)s',
  ADVANCE_SHIPMENT_NOTICE: 'ADVANCE_SHIPMENT_NOTICE:%(clientId)s:%(userId)s',
  CHARGEABLE_WEIGHT_BULK_UPLOAD: 'CHARGEABLE_WEIGHT_BULK_UPLOAD:%(clientId)s:%(userId)s',
  MDM_UPLOAD_ACTIVITY_TIME_STATUS: 'MDM_UPLOAD_ACTIVITY_TIME_STATUS:%(clientId)s:%(userId)s',
  LR_BULK_UPLOAD: 'LR_BULK_UPLOAD:%(clientId)s:%(userId)s',
  OPTIMA_INPUT_CONSTRUCTION_STATUS: 'OPTIMA_INPUT_CONSTRUCTION_STATUS:%(clientId)s:%(depotId)s:%(movement)s',
  OPTIMA_OUTPUT_QUEUE_STATUS: 'OPTIMA_OUTPUT_QUEUE_STATUS:%(clientId)s:%(optimaJobId)s',
  ERP_MATERIAL_INVOICE_EPOD_STATUS: 'ERP_INVOICE_EPOD_STATUS:%(clientId)s',
  OPTIMA_PICKLIST_DATA_TRIGGER: 'OPTIMA_PICKLIST_DATA_TRIGGER:%(clientId)s:%(progressId)s',
  OPTIMA_MATERIAL_CATEGORY_STATUS: 'OPTIMA_MATERIAL_CATEGORY_STATUS:%(clientId)s:%(userId)s',
  OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE_STATUS: 'OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE_STATUS:%(clientId)s:%(userId)s',
  MDM_UPLOAD_LEGAL_ENTITY_STATUS: 'MDM_UPLOAD_LEGAL_ENTITY_STATUS:%(clientId)s:%(userId)s',
  VEHICLE_ETA_FETCH: 'VEHICLE_ETA_FETCH:%(clientId)s:%(depotId)s:%(movement)s',
  PAY_SETTLEMENT_BULK_UPLOAD: 'PAY_SETTLEMENT_BULK_UPLOAD:%(clientId)s:%(userId)s',
  DISCARD_OPTIMA_ORDERS: 'DISCARD_OPTIMA_ORDERS:%(clientId)s:%(transactionId)s',
  OPTIMA_INDENT_TOPUP: 'OPTIMA_INDENT_TOPUP:%(clientId)s:%(transactionId)s',
  VAHAN_SARATHI_VALIDATION: 'VAHAN_SARATHI_VALIDATION:%(clientId)s:%(userId)s:%(transactionId)s',
  FIRST_IN_TRANSPORTER: 'FIRST_IN_TRANSPORTER:%(clientId)s:%(orderNo)s',
  MANUAL_FREIGHT_PROVISION_TRIGGER: 'MANUAL_FREIGHT_PROVISION_TRIGGER:%(clientId)s%(orderNo)s',
  INDENT_LR_SUMMARY_STATUS: 'INDENT_LR_SUMMARY_STATUS:%(clientId)s:%(orderNo)s',
  POD_COMPARISON_STATUS: 'POD_COMPARISON_STATUS:%(clientId)s:%(orderNo)s',
  OPTIMA_PENDING_DELIVERIES_NOTIFICATION_LOCK: 'OPTIMA_PENDING_DELIVERIES_NOTIFICATION_LOCK:%(window)s',
  OPTIMA_EXPIRE_MATERIALS_LOCK: 'OPTIMA_EXPIRE_MATERIALS_NOTIFICATION_LOCK:%(window)s',
  INDENT_ACTIONS_UPLOAD: 'INDENT_ACTIONS_UPLOAD:%(clientId)s:%(transactionId)s',
  INDENT_AUTO_REPUBLISH_TRANSPORTER_ALLOCATE: 'AUTO_REPUBLISH_ALLOCATE:%(clientId)s:%(orderNo)s',
  INDENT_NOT_DELIVERED: 'INDENT_NOT_DELIVERED:%(clientId)s:%(orderNo)s',
  MANUAL_MODIFIED_PICKLIST_TRIGGER: 'MANUAL_MODIFIED_PICKLIST_TRIGGER:%(clientId)s%(orderNo)s',
  RATE_LOOKUP_REQUEST_PROGRESS: 'RATE_LOOKUP_REQUEST_PROGRESS:%(requestId)s',
  ERP_MATERIAL_INVOICE_UPDATE: 'ERP_MATERIAL_INVOICE_UPDATE:%(clientId)s:%(userId)s',
  VAHAN_FUEL_TYPE: 'VAHAN_FUEL_TYPE:%(clientId)s:%(vehicleNumber)s',
  ERP_MATERIAL_INVOICE_UPDATE: 'ERP_MATERIAL_INVOICE_UPDATE:%(clientId)s:%(userId)s',
};

module.exports = RedisKeys;

